import { NativeModule } from "./AudioInputModule.web.ts";
import type { AudioInputState, RouteChangeEvent } from "./AudioInput.types.ts";

type ListenerSubscription = { remove(): void };

export async function startBackgroundMicrophone(): Promise<void> {}

export function stopBackgroundMicrophone(): void {}

export function onBackgroundMicrophoneStop(_listener: () => void): ListenerSubscription {
  return { remove() {} };
}

export function onVolumeChange(
  listener: (event: { volume: number }) => void,
): ListenerSubscription {
  return NativeModule.addListener("onVolumeChange", listener);
}

export async function getInputs(): Promise<AudioInputState> {
  return NativeModule.getInputs();
}

export async function setPreferredInput(uid: string | null): Promise<void> {
  return NativeModule.setPreferredInput(uid);
}

export function onRouteChange(listener: (event: RouteChangeEvent) => void): ListenerSubscription {
  return NativeModule.addListener("onRouteChange", listener);
}

export type {
  AudioInput,
  AudioInputState,
  AudioInputType,
  RouteChangeEvent,
} from "./AudioInput.types.ts";
